import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NeuralChatApiError } from "../api/client";
import { useNeuralChatAuth } from "../contexts/AuthContext";
import { getSafeNeuralChatPath } from "../utils/routes";
import { Brand, BrandCopy, BrandMark, HelperText, Input, LoginCard, LoginDescription, LoginForm, LoginPageRoot, LoginTitle, Field, PrimaryButton, ErrorNotice } from "../styles";

export const NeuralChatLoginPage: React.FC = () => {
  const auth = useNeuralChatAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const next = getSafeNeuralChatPath(new URLSearchParams(location.search).get("next"));

  useEffect(() => { if (auth.status === "authenticated") navigate(next, { replace: true }); }, [auth.status, navigate, next]);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (busy || !identifier.trim() || !password) return;
    setBusy(true); setError("");
    try { await auth.login(identifier.trim(), password); setPassword(""); navigate(next, { replace: true }); }
    catch (reason) { setError(reason instanceof NeuralChatApiError && reason.status === 429 ? "잠시 후 다시 시도해 주세요." : "아이디 또는 비밀번호를 확인해 주세요."); }
    finally { setBusy(false); }
  };

  if (auth.status === "initializing") return <LoginPageRoot><LoginCard>인증 상태를 확인하는 중…</LoginCard></LoginPageRoot>;
  return <LoginPageRoot><LoginCard><Brand><BrandMark aria-hidden="true">NN</BrandMark><BrandCopy><strong>NeuralChat</strong><span>internal team space</span></BrandCopy></Brand><LoginTitle>팀의 다음 대화</LoginTitle><LoginDescription>Neural Network 구성원만 사용할 수 있는 내부 채팅입니다. Django session으로 안전하게 로그인합니다.</LoginDescription><LoginForm onSubmit={submit}><Field><span>아이디 또는 이메일</span><Input value={identifier} onChange={(event) => setIdentifier(event.target.value)} autoComplete="username" autoFocus /></Field><Field><span>비밀번호</span><Input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="current-password" /></Field>{error && <ErrorNotice role="alert">{error}</ErrorNotice>}<PrimaryButton type="submit" disabled={busy || !identifier.trim() || !password}>{busy ? "로그인 중…" : "로그인"}</PrimaryButton></LoginForm><HelperText>세션 정보는 브라우저 저장소에 저장되지 않습니다.</HelperText></LoginCard></LoginPageRoot>;
};
